import { buildEnrollCommand } from './token-instructions/build-enroll-command.ts';

/**
 * Setting up a downloaded dnclient binary. Ordered: the service can't be registered until the
 * binary is executable, and it must be running before a host can enroll. Package installs skip all
 * three because the package's own post-install does the same work.
 */
export const BINARY_SETUP_COMMANDS = {
  makeExecutable: 'sudo chmod +x dnclient',
  installService: 'sudo ./dnclient install',
  startService: 'sudo ./dnclient start',
} as const;

/**
 * The whole binary install as one `&&`-joined command, for one-copy-paste layouts. The steps are
 * listed rather than derived so adding one is a deliberate edit here.
 */
export function binaryInstallCommand(os: 'Linux' | 'FreeBSD', downloadCommand: string, code: string): string {
  return [
    downloadCommand,
    BINARY_SETUP_COMMANDS.makeExecutable,
    BINARY_SETUP_COMMANDS.installService,
    BINARY_SETUP_COMMANDS.startService,
    buildEnrollCommand(os, code),
  ].join(' && ');
}
